import {timeStamp} from "../utils/helperFunctions";
import {SortModel} from "../components/Tables/types";
import {downloadExcel} from "../api/software";



export default class ImportExportService {

  static async downloadExcel(selectedDate: string, sortModel: SortModel) {
    const response = await downloadExcel(selectedDate, sortModel)
    const blob = await response.blob();

    const disposition = response.headers.get('Content-Disposition');
    let filename = "Kundenreport_" + timeStamp() + ".xlsx";


    if (disposition && disposition.includes('filename=')) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        // Remove quotes
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    // Create temp URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create invisible link
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);

    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }
}
